export default __webpack_public_path__ + "static/media/image1.1a634d49.jpg";